export const NSHOP_ORDER_PAYMENT_METHODS = /** @type {const} */ ({
    // 쿠콘(COOCON) CheckPay 간편결제 — 등록 계좌 기반 즉시 결제(오픈뱅킹). 백엔드 const 와 일치.
    openbank: {
        value: "openbank",
        text: "오픈뱅킹",
        desc: "등록한 계좌로 즉시 결제",
        uses: true,
        shows: true,
    },
    vaccount: {
        value: "vaccount",
        text: "가상계좌 결제",
        desc: "1회 최대 200만원 한도 내 결제 가능",
        uses: false,
        shows: false,
    },
    account: {
        value: "account",
        text: "내 통장 결제",
        desc: "1회 최대 200만원 한도 내 결제 가능",
        uses: false,
    },
    phone: {
        value: "phone",
        text: "휴대폰 결제",
        desc: "통신사별 구매한도 상이",
        uses: false,
    },
    card: {
        value: "card",
        text: "신용카드",
        desc: "결제수수료 3.5%별도\n<small>최대 월 100만원 까지 구매가능</small>",
        uses: false,
    },
});
/** @typedef {keyof typeof NSHOP_ORDER_PAYMENT_METHODS} NshopOrder_Payment_Method */
/** @type {NshopOrder_Payment_Method[]} */
export const Enum_NshopOrder_Payment_Method = Object.keys(NSHOP_ORDER_PAYMENT_METHODS);

export const NSHOP_ORDER_STATES = /** @type {const} */ ({
    // 결제준비: 주문버튼만 누른 임시상태. 웹사이트에 노출하지 않으며(목록 필터에 미포함) 하루 뒤 일괄 삭제된다.
    ORDER_PREP: { value: "ORDER_PREP", text: "결제준비" },
    ORDER_INIT: { value: "ORDER_INIT", text: "결제대기" },
    ORDER_STOP: { value: "ORDER_STOP", text: "주문취소" },
    ORDER_PAID: { value: "ORDER_PAID", text: "입금완료" },
    ISSUE_INIT: { value: "ISSUE_INIT", text: "발급요청" },
    ISSUE_FAIL: { value: "ISSUE_FAIL", text: "발급실패" },
    ISSUE_DONE: { value: "ISSUE_DONE", text: "발급완료" },
    PHONE_SENT: { value: "PHONE_SENT", text: "발송완료" },
    ORDER_DONE: { value: "ORDER_DONE", text: "충전완료" },
});
/** @typedef {keyof typeof NSHOP_ORDER_STATES} NshopOrder_State */
/** @type {NshopOrder_State[]} */
export const Enum_NshopOrder_State = Object.keys(NSHOP_ORDER_STATES);

export const List_NshopOrder_State = [
    {
        text: "전체",
        value: null,
    },
    {
        text: "결제대기",
        value: "paying",
        param: {
            $in: /** @type {NshopOrder_State[]} */ ([
                //
                "ORDER_INIT",
            ]),
        },
    },
    {
        text: "발급대기",
        value: "issuin",
        param: {
            $in: /** @type {NshopOrder_State[]} */ ([
                //
                "ORDER_PAID",
                "ISSUE_INIT",
                "ISSUE_FAIL",
            ]),
        },
    },
    {
        text: "발급완료",
        value: "issued",
        param: {
            $in: /** @type {NshopOrder_State[]} */ ([
                //
                "ISSUE_DONE",
                "PHONE_SENT",
            ]),
        },
    },
    {
        text: "충전완료",
        value: "cashed",
        param: {
            $in: /** @type {NshopOrder_State[]} */ ([
                //
                "ORDER_DONE",
            ]),
        },
    },
    {
        text: "취소주문",
        value: "cancel",
        param: {
            $in: /** @type {NshopOrder_State[]} */ ([
                //
                "ORDER_STOP",
            ]),
        },
    },
];
